import { render, staticRenderFns } from "./modalloading.vue?vue&type=template&id=033f97d2&scoped=true&"
import script from "./modalloading.vue?vue&type=script&lang=js&"
export * from "./modalloading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f97d2",
  null
  
)

export default component.exports